<template>
    <div class="header-bottom">
      <p>Test your knowledge in <b>Magic: The Gathering</b> cards</p>
      <p>and prove you master the Multiverse!</p>
    </div>
</template>

<script></script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@700&display=swap');

.header-bottom {
  padding-top: 8px;
  padding-bottom: 16px;
  text-align: center;
  font-size: 18px;
  background-color: var(--color-bg);
  color: var(--color-main-info);
}

.header-bottom-mtg {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: center;
  font-size: 18px;
  background-color: var(--color-bg);
  color: var(--color-main-info);
  font-style: italic;
}

</style>